import db from '@/db'

export default {
  namespaced: true,

  state: {
    isCollapse: false,
    user: db.user,
    routes: []
  },

  getters: {},

  actions: {},

  mutations: {
    changeCollapse (state) {
      state.isCollapse = !state.isCollapse
    },
    setUser (state, user) {
      state.user = user
      db.user = user
    },
    setRoutes (state, routes) {
      state.routes = routes
    }
  }
}
